module.exports = __webpack_public_path__ + "static/media/passport.e1358b9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet_icons/passport.svg
// module id = 37
// module chunks = 0